/**
 * ChitauriFighter.js
 * The Chitauri Fighter Enemy class
 */

import { Game } from "pixi_core";
import { BubbleColor, EnemyAbilities, GameEvents } from "../Constants";
import { Enemy } from "./Enemy";

export class ChitauriFighter extends Enemy {
    /**
     * @public
     * @param {String} enemyName
     * @param {Object} enemyData
     * @param {Number} index
     * @param {Boolean} [summoned] - Summoned by an ability
     */
    constructor(enemyName, enemyData, index, summoned) {
        super(enemyName, enemyData, index, summoned);

        const probAddRandom = Game.utils.assertNumber(enemyData.ProbAddRandom, 1);
        const probDefend = Game.utils.assertNumber(enemyData.ProbDefend, 1);

        // Ability choices
        this._abilityChoices.addChoice(EnemyAbilities.eADD_RANDOM, probAddRandom);
        this._abilityChoices.addChoice(EnemyAbilities.eDEFEND, probDefend);

        /** @private @type {Number} - Number of bubbles to cast with the Defend ability */
        this._nbBubblesDefend = Game.utils.assertNumber(enemyData.NbBubblesDefend, 1);
    }

    /**
     * @protected
     * @override
     * @param {EnemyAbilities} abilityName
     * @param {{x: Number, y: Number}} startPos
     */
    _useAbility(abilityName, startPos) {
        switch (abilityName) {
            case EnemyAbilities.eADD_RANDOM:
                let addBubbleData = {
                    nbBubbles: this._nbBubblesAdd,
                    color: BubbleColor.eRANDOM,
                    startPos: startPos,
                    dodgeFirst: false,
                    callback: this._onAbilityCompleted.bind(this)
                };
                Game.fire(GameEvents.eGAME_ABILITY_ADD_BUBBLE, addBubbleData);
                break;
            case EnemyAbilities.eDEFEND:
                Game.fire(
                    GameEvents.eGAME_ABILITY_TRANSFORM_TO_SHIELD,
                    this._nbBubblesDefend,
                    startPos,
                    this._onAbilityCompleted.bind(this)
                );
                break;
            default:
                console.error("[ChitauriFighter._useAbility] Invalid ability name : " + abilityName);
                this._chooseNextAction();
        }
    }
}
